import React, { useState } from "react";
import { Flex } from "rebass/styled-components";

import { LabelReadOnly } from "../../../../Components/Form/Label";
import { Button } from "../../../../Components/Button";
import { useIsDesktopApp } from "../../../../Hooks/useIsDesktopApp";
import { LinkedAccountsViewModel } from "../../ViewModel";

import {
  DisabledButton,
  IconWrapper,
  StyledDiscordIcon,
  UnlinkButton,
} from "../styledComponents";
import { useHistory } from "react-router-dom";
import { URLS } from "../../../../Utilities/Maps";
import { useUser } from "../../../../Hooks/useUser";

const { REACT_APP_BASE_URL } = process.env;

const LinkDiscord = ({ buttonText }: { buttonText: string }) => {
  const { unlinkAccount } = LinkedAccountsViewModel();
  const { allstarUser } = useUser();
  const discordUsedForSignup = allstarUser.user.discordSignUp;
  const { isDesktop } = useIsDesktopApp();
  const [linked, setLinked] = useState(!!allstarUser?.user?.discord?.username);
  const history = useHistory();
  const link = async (id: string, isDesktopApp: string | boolean | null) => {
    if (isDesktop) {
      window.parent.postMessage(
        {
          type: "openLink",
          link: `${REACT_APP_BASE_URL}${URLS.AUTH_ROUTES.DISCORD}?flow=link&referrer=DESKTOP_APP`,
        },
        "*",
      );
      return;
    }

    history.push(
      `${URLS.AUTH_ROUTES.DISCORD}?flow=link&referrer=CONNECTED_ACCOUNTS`,
    );
  };

  const unlink = async () => {
    await unlinkAccount({ variables: { accountType: "discord" } });
    setLinked(!linked);
  };

  return (
    <Flex pt={5} alignItems="center">
      <IconWrapper>
        <StyledDiscordIcon />
      </IconWrapper>
      {linked ? (
        <Flex width="100%" style={{ gap: "8px" }} alignItems={"center"}>
          <LabelReadOnly
            label={"Discord"}
            text={allstarUser.user?.discord?.username}
          />
          {discordUsedForSignup ? (
            <DisabledButton
              size="small"
              flex={true}
              maxWidth={2}
              classification="secondary"
              title="You cannot unlink your primary login account."
              disabled
            >
              Unlink
            </DisabledButton>
          ) : (
            <UnlinkButton
              size="small"
              flex={true}
              maxWidth={2}
              classification="secondary"
              onClick={() => unlink()}
            >
              Unlink
            </UnlinkButton>
          )}
        </Flex>
      ) : (
        <Button
          size="small"
          flex={true}
          maxWidth={2}
          width="100%"
          classification="secondary"
          target="_blank"
          onClick={() => link(allstarUser.user._id, isDesktop)}
        >
          {buttonText}
        </Button>
      )}
    </Flex>
  );
};

export { LinkDiscord };
